export const PRODUCT_STATUS = {
  T: "productstatus_t",
  E: "productstatus_e",
  R: "productstatus_r",
  B: "productstatus_b",
};